import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { DeviceDetailCore } from '../useDeviceDetail';
import { useDevicesDetailsRaw } from './useDevicesDetailsRaw';
import { JsonPanel } from './JsonPanel';
import { useClientAccess } from '../../../hooks/useClientAccess';
import { maskSecrets } from '../../../utils/secrets';

interface Props {
  core: DeviceDetailCore;
}

/** The DeviceDetail payload as the API returns it, for support and debugging. */
export const DevicesDetailsRaw: React.FC<Props> = ({ core }) => {
  const { t } = useI18n();
  const r = useDevicesDetailsRaw(core);
  const { isAnepStaff } = useClientAccess();

  return (
    <JsonPanel
      title="Device Detail (Raw JSON)"
      data={isAnepStaff ? r.deviceDetail : maskSecrets(r.deviceDetail)}
      loading={r.refreshing}
      loadingLabel="Loading device detail..."
      onRefresh={r.refresh}
      refreshTitle={t('devices.refreshDeviceDetail')}
    />
  );
};
